/* Free shipping progress row.
 
   Reads /cart.js and fills the row in, then re-reads whenever the cart
   changes. Also moves itself next to the Add to cart button, above or
   below it depending on data-position.
 
   WHY THE BAR COLOUR IS SET HERE AND NOT IN CSS. The stylesheet does carry
   `.pc-fs[data-qualified="true"] .pc-fs__fill { background: green }`, the
   element matches that selector, and it is more specific than the red base
   rule, yet it lost the cascade on the live page. Rather than escalate with
   !important and hope, the colour is written inline, which nothing in a
   theme or app stylesheet can out-rank. The CSS rules stay as a fallback for
   anyone reading the file.
 
   WHY IT MOVES ITSELF. Quantity and Add to cart are both children of
   .m-product-form--wrapper, a wrapping flex row inside the buy buttons
   block. A theme block can only be placed above that whole block, which
   puts the row above the quantity selector rather than against the button.
   Inserting the node beside the button, as a full width flex item, lands it
   where it was asked for. place() is idempotent and re-runs after cart
   updates, so a re-render of the buy buttons cannot strand it.
 
   HOW IT KNOWS THE CART CHANGED. Four triggers, because no single one is
   reliable on a store with this many apps touching the cart:
 
     1. .m-cart-count-bubble changes. The theme rewrites it on every cart
        change it performs, whatever triggered it. This is the main signal.
     2. A click on any add to cart control, re-checked after a delay. Covers
        an app that writes to the cart without telling the theme, which
        leaves the bubble untouched and signal 1 silent.
     3. Tab becoming visible again, for a cart changed in another tab.
     4. pageshow, because a back button restore does not re-run page scripts.
 
   Requests are deduplicated by the `pending` flag, so overlapping triggers
   cost one fetch, not four. */
 
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pending = false;
 
  var COLOUR_PENDING = '#D62828';
  var COLOUR_DONE = '#2F6B4F';
 
  function money(cents) {
    return 'R ' + (cents / 100).toFixed(2);
  }
 
  function place() {
    var bars = document.querySelectorAll('[data-pc-fs]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var block = document.querySelector('.main-product__block-buy_buttons');
      if (!block) continue;
      var btn = block.querySelector('button[name="add"]');
      if (!btn || !btn.parentElement) continue;
 
      var below = bar.getAttribute('data-position') === 'below';
      if (below) {
        if (btn.nextElementSibling === bar) continue;
        btn.parentElement.insertBefore(bar, btn.nextSibling);
      } else {
        if (btn.previousElementSibling === bar) continue;
        btn.parentElement.insertBefore(bar, btn);
      }
      bar.classList.add('pc-fs--inline');
    }
  }
 
  function paint(bar, total) {
    var threshold = Number(bar.getAttribute('data-threshold')) || 0;
    if (!threshold) return;
 
    var remaining = Math.max(0, threshold - total);
    var fill = bar.querySelector('[data-pc-fs-fill]');
    var msg = bar.querySelector('[data-pc-fs-msg]');
    var icon = bar.querySelector('.pc-fs__icon');
 
    if (remaining === 0) {
      bar.setAttribute('data-qualified', 'true');
      if (msg) {
        msg.textContent = bar.getAttribute('data-msg-done') || '';
        msg.style.color = COLOUR_DONE;
        msg.style.fontWeight = '600';
      }
      if (icon) icon.style.color = COLOUR_DONE;
      if (fill) {
        fill.style.backgroundColor = COLOUR_DONE;
        fill.style.width = '100%';
      }
    } else {
      bar.setAttribute('data-qualified', 'false');
      var parts = (bar.getAttribute('data-msg-pending') || '').split('{amount}');
      if (msg) {
        msg.textContent = '';
        msg.appendChild(document.createTextNode(parts[0] || ''));
        var strong = document.createElement('strong');
        strong.textContent = money(remaining);
        msg.appendChild(strong);
        msg.appendChild(document.createTextNode(parts[1] || ''));
        msg.style.color = '';
        msg.style.fontWeight = '';
      }
      if (icon) icon.style.color = '';
      if (fill) {
        fill.style.backgroundColor = COLOUR_PENDING;
        fill.style.width = Math.min(100, Math.round((total / threshold) * 100)) + '%';
      }
    }
 
    bar.removeAttribute('hidden');
  }
 
  function update() {
    var bars = document.querySelectorAll('[data-pc-fs]');
    if (!bars.length || pending) return;
    pending = true;
 
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        place();
        for (var i = 0; i < bars.length; i++) paint(bars[i], cart.total_price || 0);
      })
      .catch(function (err) {
        /* Leave the row as it was rather than showing a wrong number. */
        console.error('[pc-free-shipping]', err);
      })
      .then(function () { pending = false; });
  }
 
  function watchCartCount() {
    var bubble = document.querySelector('.m-cart-count-bubble');
    if (!bubble || !window.MutationObserver) return;
    new MutationObserver(function () {
      setTimeout(update, 150);
    }).observe(bubble, { childList: true, characterData: true, subtree: true, attributes: true });
  }
 
  function watchAddClicks() {
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (t.closest('button[name="add"], .m-add-to-cart, [data-pc-ft-input]')) {
        setTimeout(update, 1200);
        setTimeout(update, 2600);
      }
    });
  }
 
  function init() {
    place();
    update();
    watchCartCount();
    watchAddClicks();
    /* The variant picker can re-render the buy buttons shortly after load. */
    setTimeout(place, 1200);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  window.addEventListener('pageshow', update);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) update();
  });
})();